export const rules = {
  name: [
    { required: true, message: 'Пожалуйста укажите наименование', trigger: 'blur' },
  ],
  branch_id: [
    { required: true, message: 'Пожалуйста, введите корпус ', trigger: 'blur' },
],
};